import axios from "axios";
import { host } from "./utilities";

axios.defaults.withCredentials = true;
export const cashServiceHealthCheckAxios = () => (config) => axios.get(`${host()}/health-check`, config);
